import { type ActionItem } from 'shared/ui'
import { type PersonalAccessTokenRow } from 'pages/settings/pages/developer/pages/accessTokens/model/PersonalAccessTokenRow'
import { type AccessTokensStore } from 'pages/settings/pages/developer/pages/accessTokens/store/accessTokensStore'

export const getAccessTokensTableActions = (
  row: PersonalAccessTokenRow,
  store: AccessTokensStore
): ActionItem[] => [
  {
    icon: 'delete',
    text: 'Revoke',
    onAction: () => store.openRevokeModal(row.origin),
    iconButtonProps: {
      size: 'small',
      fontSize: 16,
      color: 'tertiary',
      ariaLabel: 'Revoke token',
    },
  },
]
